/*
 * @Description:Content Group.
 * @Author: Luke Z
 * @Date: 2021-03-10 13:10:25
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-08 10:26:32
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/ContentGroup/index.tsx
 */

import React from 'react';

import css from './css.less';

import { useSelector } from 'react-redux';

import CollapseGroup from 'src/components/CollapseGroup';

import { get } from 'lodash';
import { EDMBody, EDMHeader } from './EDM';
import ErrorNotice from './ErrorNotice';

import {
  EnumModuleType,
  moduleHeaderProperties,
  staticModuleType,
} from 'src/constrains/DraggableModules/tools';
import { ActionType } from 'src/types/common/common';

import ContentCollapseHeader from 'src/constrains/DraggableModules/ContentCollapseHeader';
import { ContentModuleGroupPreloadingContext } from 'src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';
import {
  generateArticleCarousel,
  generateArticleList,
  generateCarousel,
  generateLongCanvas,
  generatePoster,
  generateProductCarousel,
  generateProductGridDisplay,
  generateProductListDisplay,
  generateResponsiveContentGrid,
  generateResponsiveContentPageCarousel,
  generateResponsiveContentTab,
  generateResponsiveImageCarousel,
  generateResponsivePoster,
  generateResponsivePosterTab,
  generateResponsiveProductCarousel,
  generateResponsiveProductGrid,
  generateResponsiveProductTab,
  generateResponsiveSubscription,
  generateResponsiveText,
  generateSubscription,
  generateText,
  generateVideo,
} from './ModulesGenerator';
//import { ContentSelection } from 'src/constrains/DraggableModules/PreloadComponent/ContentPageSelection/index';
//import CollapseErr from '@/src/constrains/SalesChannelPreviewPageComponents/CollapseErrors';
import { ErrorBoundary } from 'src/components/ErrorBoundary';

const ContentGroup = (props) => {
  const {
    data = [],
    droppableId,
    getContent,
    getErrorDisplay,
    onDynamicChange,
    onStaticChange,
    onOrderListOnChange,
    onCollapseOpen,
    getOpeningCollapse,
    getVisibleCollapse,
    //To Do Delete Link Temp
    linkSet,
    extraProps: _extra,
    onErrorChange,
    getCollapseStatus,
    onModuleTypeChange,
    disabled,
    onDuplicate,
    onModuleReset,
    allDisabled,
    hideEdit,
    //getCollapseOpenStatus,
  } = props;
  const { options } = React.useContext(ContentModuleGroupPreloadingContext);
  const inUsePages = get(options, 'inUsePages');
  const extraProps = { ...(_extra || {}), contentPages: inUsePages };

  //整体模块的onChange=====start=================
  const handleOnModuleOrderListSort = (from, to) => {
    if (onOrderListOnChange) {
      onOrderListOnChange({
        type: ActionType.reorder,
        data: {
          from,
          to,
        },
      });
    }
  };

  const handleOnModuleOrderListDelete = (id) => {
    if (onOrderListOnChange) {
      onOrderListOnChange({
        type: ActionType.delete,
        id,
      });
    }
  };
  //整体模块的onChange=====End=================

  const Modules = React.useMemo(() => {
    const common = {
      onDynamicChange,
      onStaticChange,
      onModuleTypeChange: onModuleTypeChange,
      onCollapseOpen,
      disabled,
      allDisabled,
      hideEdit,
    };
    return {
      [EnumModuleType.Carousel]: generateCarousel(common), //Added allDisabled
      [EnumModuleType.ProductCarousel]: generateProductCarousel(common), //Added allDisabled
      [EnumModuleType.Poster]: generatePoster(common), // Added disabled And allDisabled
      [EnumModuleType.LongCanvas]: generateLongCanvas(common), // Added disabled and allDisabled
      [EnumModuleType.Text]: generateText(common), // Added disabled
      [EnumModuleType.ProductGrid]: generateProductGridDisplay(common), //Added allDisabled
      [EnumModuleType.ProductList]: generateProductListDisplay(common), // Added allDisabled
      [EnumModuleType.Subscription]: generateSubscription(common), // Added allDisabled
      [EnumModuleType.ArticleCarousel]: generateArticleCarousel(common), //Added allDisabled
      [EnumModuleType.ArticleList]: generateArticleList(common), //Added allDisabled
      [EnumModuleType.Video]: generateVideo(common), // Added disabled
      [EnumModuleType.ResponsiveImageCarousel]:
        generateResponsiveImageCarousel(common),
      [EnumModuleType.ResponsiveProductCarousel]:
        generateResponsiveProductCarousel(common),
      [EnumModuleType.ResponsiveContentCarousel]:
        generateResponsiveContentPageCarousel(common),
      [EnumModuleType.ResponsiveSubscription]:
        generateResponsiveSubscription(common),
      [EnumModuleType.ResponsivePoster]: generateResponsivePoster(common),
      [EnumModuleType.ResponsiveProductGrid]:
        generateResponsiveProductGrid(common),
      [EnumModuleType.ResponsiveContentGrid]:
        generateResponsiveContentGrid(common),
      [EnumModuleType.ResponsiveText]: generateResponsiveText(common),

      [EnumModuleType.ResponsivePosterTab]: generateResponsivePosterTab(common),
      [EnumModuleType.ResponsiveProductTab]:
        generateResponsiveProductTab(common),
      [EnumModuleType.ResponsiveContentTab]:
        generateResponsiveContentTab(common),
      //generateResponsiveContentTab
      [EnumModuleType.Edm]: { component: EDMBody, props: {} },
    };
  }, [allDisabled]);
  const ModuleHeader = React.useMemo(() => {
    return {
      [EnumModuleType.Carousel]: {
        component: ContentCollapseHeader,
      },
      [EnumModuleType.ProductCarousel]: {
        component: ContentCollapseHeader,
      },
      [EnumModuleType.Poster]: {
        component: ContentCollapseHeader,
      },
      [EnumModuleType.LongCanvas]: {
        component: ContentCollapseHeader,
      },
      [EnumModuleType.Text]: {
        component: ContentCollapseHeader,
      },
      [EnumModuleType.ProductGrid]: {
        component: ContentCollapseHeader,
      },
      [EnumModuleType.ProductList]: {
        component: ContentCollapseHeader,
      },
      [EnumModuleType.Subscription]: {
        component: ContentCollapseHeader,
        props: {},
      },
      [EnumModuleType.ArticleCarousel]: {
        component: ContentCollapseHeader,
        props: {},
      },
      [EnumModuleType.ArticleList]: {
        component: ContentCollapseHeader,
        props: {},
      },
      [EnumModuleType.Video]: {
        component: ContentCollapseHeader,
        props: {},
      },
      [EnumModuleType.ResponsiveImageCarousel]: {
        component: ContentCollapseHeader,
        props: {},
      },
      [EnumModuleType.ResponsiveProductCarousel]: {
        component: ContentCollapseHeader,
        props: {},
      },
      [EnumModuleType.ResponsiveContentCarousel]: {
        component: ContentCollapseHeader,
        props: {},
      },
      [EnumModuleType.ResponsiveSubscription]: {
        component: ContentCollapseHeader,
        props: {},
      },
      [EnumModuleType.ResponsivePoster]: {
        component: ContentCollapseHeader,
        props: {},
      },
      [EnumModuleType.ResponsiveProductGrid]: {
        component: ContentCollapseHeader,
        props: {},
      },
      [EnumModuleType.ResponsiveContentGrid]: {
        component: ContentCollapseHeader,
        props: {},
      },
      [EnumModuleType.ResponsiveText]: {
        component: ContentCollapseHeader,
        props: {},
      },
      [EnumModuleType.ResponsivePosterTab]: {
        component: ContentCollapseHeader,
        props: {},
      },
      [EnumModuleType.ResponsiveProductTab]: {
        component: ContentCollapseHeader,
        props: {},
      },
      [EnumModuleType.ResponsiveContentTab]: {
        component: ContentCollapseHeader,
        props: {},
      },
      [EnumModuleType.Edm]: { component: EDMHeader, props: {} },
    };
  }, []);

  const ModuleGenerator = ({ props: _props, type }) => {
    const { component: Module, props } = Modules[type];
    const _p = { ...props, ..._props };

    if (Module) {
      return (
        <ErrorBoundary>
          <Module {..._p} />
        </ErrorBoundary>
      );
    }
  };
  const ModuleHeaderGenerator = ({ props, type }) => {
    const { component: Header } = ModuleHeader[type];
    return <Header {...props} />;
  };

  const renderData = React.useMemo(() => {
    return data.map(({ draggableId, moduleType }) => {
      const basic = {
        draggableId,
        moduleType,
      };

      const commonProps = (_props = {}) => ({
        draggableId,
        getContent,
        getErrorDisplay,
        //isOpen,
        droppableId: `${draggableId}${
          (moduleHeaderProperties[moduleType] || {}).name
        }`,
        //To Do Delete Link Temp
        linkSet,
        extraProps,
        onErrorChange,
        getCollapseStatus,
        ..._props,
      });

      const headerProps = (_props = {}) => ({
        onDelete: handleOnModuleOrderListDelete,
        draggableId,
        moduleType,
        getContent,
        onStaticChange,
        getErrorDisplay,
        extraProps,
        disabled: disabled || allDisabled,
        onDuplicate,
        onReset: onModuleReset,
        ..._props,
        //isOpen,
      });

      return {
        ...basic,
        titleGenerator: (
          { open }, //这里最好不要用generate
        ) =>
          ModuleHeaderGenerator({
            type: moduleType,
            props: headerProps({ open }),
          }),
        content: ModuleGenerator({
          type: moduleType,
          props: commonProps({}),
        }),
      };
    });
  }, [data, extraProps]);

  const handleOnListChange = (openArr) => {
    if (onCollapseOpen) onCollapseOpen(openArr);
  };

  const filtratedData = React.useMemo(() => {
    return data.filter((i) => !staticModuleType.includes(i.moduleType));
  }, [data]);

  return (
    <React.Fragment>
      <div className={css.warning}>
        <ErrorNotice
          data={filtratedData}
          getVisibleCollapse={getVisibleCollapse}
          disabled={disabled}
        />
      </div>

      <_Collapse
        getOpeningCollapse={getOpeningCollapse}
        handleOnListChange={handleOnListChange}
        data={data}
        renderData={renderData}
        droppableId={droppableId}
        handleOnModuleOrderListSort={handleOnModuleOrderListSort}
        disabled={disabled}
        allDisabled={allDisabled}
      />
    </React.Fragment>
  );
};
export default ContentGroup;
const _Collapse = (props) => {
  const {
    droppableId,
    getOpeningCollapse,
    data,
    handleOnListChange,
    renderData,
    handleOnModuleOrderListSort,
    disabled,
    allDisabled,
  } = props;

  const openingCollapse: string[] = useSelector(getOpeningCollapse(data));

  return (
    <ErrorBoundary>
      <CollapseGroup
        openList={openingCollapse}
        onClickTitle={handleOnListChange}
        data={renderData}
        droppableId={droppableId}
        onSort={handleOnModuleOrderListSort}
        disabled={disabled || allDisabled}
      />
    </ErrorBoundary>
  );
};
